$(function () {
    $( document ).ready(function() {
        $(window).on('scroll', function (e) {
            if ($(this).scrollTop() > 300) {
                $('.scrollTop').fadeIn();
            } else {
                $('.scrollTop').fadeOut();
            }
        });

        $('.scrollTop')
            .on('click', function (e) {
                $('html, body').animate({scrollTop: 0}, 400);
                return false;
            })
        ;


        //********** Scroll  ***************************************//
        $('.js-scrollTo').on('click', function () {
            var goscroll = false;
            var the_hash = $(this).attr("href");
            var regex = new RegExp("(.*)\#(.*)", "gi");
            var the_element = '';
            if (the_hash.match("\#(.+)")) {

                the_hash = the_hash.replace(regex, "$2");
                if ($("#" + the_hash).length > 0) {
                    the_element = "#" + the_hash;
                    goscroll = true;
                }
                else if ($("a[name=" + the_hash + "]").length > 0) {
                    the_element = "a[name=" + the_hash + "]";
                    goscroll = true;
                }

                if (goscroll) {
                    var headerHeight = $('#navbar').outerHeight();
                    var to = $(the_element).offset().top - headerHeight - 40;
                    $('html, body').animate({
                        scrollTop: to
                    }, 750);
                    return false;
                }
            }
        });
    });
});
